export default __webpack_public_path__ + "static/media/table.9b77a08d.png";